import {List} from 'immutable';
import {groupAlarmSituations, isAssistanceRequestAlarm} from '../../utils/models/v4AlarmSituation';
import {AssistanceRequestIcon} from '../../utils/icons';
import {moduleIds} from '../../utils/models/Module';
import {getWhitelabel} from '../../env';

// V4 requests list on the Assistance requests page wherever a V3 end user has it (as the menu and
// routes offer it), not in Alerts. Everyone else, V4-only sessions included, keeps them in Alerts.
export const v4RequestsOnOwnPage = (user) =>
    !!user && user.isUser && !user.isV4Only && !user.isAlarmCenter && !user.isPresentation
    && user.hasModule(moduleIds.AssistanceRequests) && !getWhitelabel()?.simpleView;

export function getAlarms(props) {
    const {user, showARCAlarms} = props;
    let {alarms} = props;
    // Filtered only when one is there, so a plain V3 list keeps its identity.
    if (v4RequestsOnOwnPage(user) && alarms.some(isAssistanceRequestAlarm)) {
        alarms = alarms.filter(a => !isAssistanceRequestAlarm(a));
    }
    if (user.isMonitorUser && !showARCAlarms) {
        return alarms.filter(a => !a.get('arc'));
    }
    return alarms;
}

// Situations (grouped rows, response pane, one close) are V4-only UI. V3 sessions, alarm centres
// and presentation screens keep one row per alarm and close only what was picked.
export const usesAlarmSituations = (user) =>
    !!(user && user.isV4Only && !user.isAlarmCenter && !user.isPresentation);

// A request reads as one only where situations are on; elsewhere it keeps the generic label.
export const alarmTypeName = (alarm, user) =>
    usesAlarmSituations(user) && alarm.isAssistanceRequest ? 'assistanceRequest' : alarm.typeName;

export const alarmIcon = (alarm, user) =>
    usesAlarmSituations(user) && alarm.isAssistanceRequest ? AssistanceRequestIcon : alarm.icon;

// Grouped before splitting: a closed root alarm with an open request still lists as open.
export function situationRows(alarms, {group = true} = {}) {
    if (!group) {
        const all = List(alarms || []);
        return {open: all.filter((a) => !a.state), closed: all.filter((a) => a.state), byKey: new Map()};
    }
    const open = [];
    const closed = [];
    const byKey = new Map();
    groupAlarmSituations(alarms).forEach((situation) => {
        byKey.set(situation.key, situation);
        (situation.isOpen ? open : closed).push(situation.root);
    });
    return {open: List(open), closed: List(closed), byKey};
}

// A closed V4 root still listed open for its open requests may close again, taking just those.
export function canCloseRow(alarm, {situation = null, device = null, situationsOn = false} = {}) {
    if (alarm.canClose(device)) return true;
    if (!situationsOn || alarm.isOpen || !alarm.get('v4')) return false;
    return !!situation?.requests?.some((r) => r.isOpen);
}
